import { useSearchParams } from "react-router-dom";
import { useCallback } from "react";

export default function useCustomSearchParam() {
  const [searchParams, setSearchParams] = useSearchParams();

  /**
   *
   * @param name
   * @param value
   */
  const addParamToQueryString = useCallback((name: any, value: any) => {
    const newParams = new URLSearchParams(searchParams.toString());
    if (value === null) {
      newParams.delete(name);
    } else {
      newParams.set(
        name,
        Array.isArray(value) ? JSON.stringify(value) : value
      );
    }
    setSearchParams(newParams);
  }, [searchParams, setSearchParams]);

  /**
   *
   * @param name
   * @param value
   */
  const removeParamFromQueryString = useCallback((name: any) => {
    const newParams = new URLSearchParams(searchParams.toString());
    name?.map((param: any) => {
      newParams.delete(param);
    });
    setSearchParams(newParams);
  }, [searchParams, setSearchParams]);

  /**
   *
   */
  const removeAllParamsFromQueryString = useCallback(() => {
    setSearchParams(new URLSearchParams());
  }, [setSearchParams]);

  return {
    addParamToQueryString,
    removeParamFromQueryString,
    searchParams,
    setSearchParams,
    removeAllParamsFromQueryString,
  };
}
